module.exports = __webpack_public_path__ + "img/act_pro_img24s_03.d807c61c.png";